import { useRef, useEffect, useState } from 'react';
import Slider from 'react-slick';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { description, settings, slidesConfig, title } from './data';
import { ROUTES } from 'utils/routeNames';
import { ImageLazy } from 'components/ImageLazy';
import { WarningModal } from 'containers/Welcome/fragments/WarningModal';
import { useOutsideClick } from 'hooks/useOutsideClick';
import {
  ContentContainer,
  ModalWrapper,
  Content,
  StyledTitle,
  StyledSubTitle,
  StyledButton,
  StyledSliderContainer,
} from './styled';

export const MainSection = () => {
  const { user } = useSelector(({ auth }) => auth);
  const [sliderHeight, setSliderHeight] = useState(0);
  const navigate = useNavigate();
  const offsetHeight = useRef(null);
  const { ref, isOpen, setIsOpen } = useOutsideClick();

  const info = localStorage.getItem('credentials');

  const handleClick = () => {
    if (info) {
      if (
        user?.data?.birthdate === null ||
        user?.data?.country === null ||
        user?.data?.city === null ||
        user?.city?.gender === null
      ) {
        setIsOpen(true);
      } else {
        navigate(ROUTES.REQUESTS);
      }
    } else {
      navigate(ROUTES.LOGIN);
    }
  };

  useEffect(() => {
    setSliderHeight(offsetHeight.current.offsetHeight);
  }, [offsetHeight?.current?.offsetHeight]);

  return (
    <Content>
      <StyledSliderContainer ref={offsetHeight}>
        <Slider {...settings}>
          {slidesConfig.map((item) => (
            <ImageLazy
              height={sliderHeight}
              width="100%"
              key={item.id}
              hash={item.hash}
              src={item.img}
              alt="Travel Slide"
            />
          ))}
        </Slider>
      </StyledSliderContainer>
      {isOpen && (
        <ModalWrapper ref={ref}>
          <WarningModal />{' '}
        </ModalWrapper>
      )}
      <ContentContainer>
        <StyledTitle>{title}</StyledTitle>
        <StyledSubTitle>{description}</StyledSubTitle>

        <StyledButton onClick={handleClick}>Start your trip</StyledButton>
      </ContentContainer>
    </Content>
  );
};
